export default __webpack_public_path__ + "static/media/cable_tv.14bf10ed.webp";